const SidebarMixin = {
  data () {
    return {
      isSidebarShow: false
    }
  },
  methods: {
    onShowSidebar () {
      this.isSidebarShow = true
      this.toggleClasses()
    },
    onCloseSidebar () {
      this.isSidebarShow = false
      this.toggleClasses()
    },
    toggleClasses () {
      if (document.querySelector('#portletFoot')) {
        document.querySelector('#portletFoot').classList.toggle('sticky-bottom')
      }
      if (document.querySelector('#portletFoot button')) {
        document.querySelector('#portletFoot button').classList.toggle('invisible')
      }
    }
  }
}

export default SidebarMixin
